import { injectBrandFonts, type BrandFontFace } from '../../../shared/font-injector';

const FONT_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/ESPN/fonts`;

const FONTS: BrandFontFace[] = [
  // ESPN Pro Loud
  {
    family: 'ESPN Pro Loud',
    weight: 500,
    style: 'oblique',
    woff2: 'ESPNProLoud-Medium.woff2',
    file: 'ESPNProLoud-Medium.ttf',
    format: 'truetype'
  },
  {
    family: 'ESPN Pro Loud',
    weight: 500,
    style: 'italic',
    woff2: 'ESPNProLoud-MediumOblique.woff2',
    file: 'ESPNProLoud-MediumOblique.ttf',
    format: 'truetype'
  },

  // Playoff
  {
    family: 'Playoff',
    weight: 400,
    style: 'normal',
    woff2: 'PlayoffRegular.woff2',
    file: 'PlayoffRegular.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 400,
    style: 'italic',
    woff2: 'PlayoffRegularItalic.woff2',
    file: 'PlayoffRegularItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 500,
    style: 'normal',
    woff2: 'PlayoffMedium.woff2',
    file: 'PlayoffMedium.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 500,
    style: 'italic',
    woff2: 'PlayoffMediumItalic.woff2',
    file: 'PlayoffMediumItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 700,
    style: 'normal',
    woff2: 'PlayoffBold.woff2',
    file: 'PlayoffBold.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 700,
    style: 'italic',
    woff2: 'PlayoffBoldItalic.woff2',
    file: 'PlayoffBoldItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 800,
    style: 'normal',
    woff2: 'PlayoffHeavy.woff2',
    file: 'PlayoffHeavy.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 800,
    style: 'italic',
    woff2: 'PlayoffHeavyItalic.woff2',
    file: 'PlayoffHeavyItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 900,
    style: 'normal',
    woff2: 'PlayoffBlack.woff2',
    file: 'PlayoffBlack.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff',
    weight: 900,
    style: 'italic',
    woff2: 'PlayoffBlackItalic.woff2',
    file: 'PlayoffBlackItalic.otf',
    format: 'opentype'
  },

  // Playoff Cond (sin italics)
  {
    family: 'Playoff Cond',
    weight: 400,
    style: 'normal',
    woff2: 'PlayoffRegularCond.woff2',
    file: 'PlayoffRegularCond.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Cond',
    weight: 500,
    style: 'normal',
    woff2: 'PlayoffMediumCond.woff2',
    file: 'PlayoffMediumCond.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Cond',
    weight: 700,
    style: 'normal',
    woff2: 'PlayoffBoldCond.woff2',
    file: 'PlayoffBoldCond.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Cond',
    weight: 900,
    style: 'normal',
    woff2: 'PlayoffBlackCond.woff2',
    file: 'PlayoffBlackCond.otf',
    format: 'opentype'
  },

  // Playoff Pro Cond
  {
    family: 'Playoff Pro Cond',
    weight: 400,
    style: 'normal',
    woff2: 'PlayoffProCond-Regular.woff2',
    file: 'PlayoffProCond-Regular.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 400,
    style: 'italic',
    woff2: 'PlayoffProCond-RegularItalic.woff2',
    file: 'PlayoffProCond-RegularItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 500,
    style: 'normal',
    woff2: 'PlayoffProCond-Medium.woff2',
    file: 'PlayoffProCond-Medium.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 500,
    style: 'italic',
    woff2: 'PlayoffProCond-MediumItalic.woff2',
    file: 'PlayoffProCond-MediumItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 700,
    style: 'normal',
    woff2: 'PlayoffProCond-Bold.woff2',
    file: 'PlayoffProCond-Bold.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 700,
    style: 'italic',
    woff2: 'PlayoffProCond-BoldItalic.woff2',
    file: 'PlayoffProCond-BoldItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 900,
    style: 'normal',
    woff2: 'PlayoffProCond-Black.woff2',
    file: 'PlayoffProCond-Black.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Cond',
    weight: 900,
    style: 'italic',
    woff2: 'PlayoffProCond-BlackItalic.woff2',
    file: 'PlayoffProCond-BlackItalic.otf',
    format: 'opentype'
  },

  // Playoff Pro Sans
  {
    family: 'Playoff Pro Sans',
    weight: 200,
    style: 'normal',
    woff2: 'PlayoffProSans-XLight.woff2',
    file: 'PlayoffProSans-XLight.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 200,
    style: 'italic',
    woff2: 'PlayoffProSans-XLightItalic.woff2',
    file: 'PlayoffProSans-XLightItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 300,
    style: 'normal',
    woff2: 'PlayoffProSans-Light.woff2',
    file: 'PlayoffProSans-Light.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 300,
    style: 'italic',
    woff2: 'PlayoffProSans-LightItalic.woff2',
    file: 'PlayoffProSans-LightItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 400,
    style: 'normal',
    woff2: 'PlayoffProSans-Regular.woff2',
    file: 'PlayoffProSans-Regular.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 400,
    style: 'italic',
    woff2: 'PlayoffProSans-RegularItalic.woff2',
    file: 'PlayoffProSans-RegularItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 500,
    style: 'normal',
    woff2: 'PlayoffProSans-Medium.woff2',
    file: 'PlayoffProSans-Medium.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 500,
    style: 'italic',
    woff2: 'PlayoffProSans-MediumItalic.woff2',
    file: 'PlayoffProSans-MediumItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 700,
    style: 'normal',
    woff2: 'PlayoffProSans-Bold.woff2',
    file: 'PlayoffProSans-Bold.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 700,
    style: 'italic',
    woff2: 'PlayoffProSans-BoldItalic.woff2',
    file: 'PlayoffProSans-BoldItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 800,
    style: 'normal',
    woff2: 'PlayoffProSans-Heavy.woff2',
    file: 'PlayoffProSans-Heavy.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 800,
    style: 'italic',
    woff2: 'PlayoffProSans-HeavyItalic.woff2',
    file: 'PlayoffProSans-HeavyItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 900,
    style: 'normal',
    woff2: 'PlayoffProSans-Black.woff2',
    file: 'PlayoffProSans-Black.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Pro Sans',
    weight: 900,
    style: 'italic',
    woff2: 'PlayoffProSans-BlackItalic.woff2',
    file: 'PlayoffProSans-BlackItalic.otf',
    format: 'opentype'
  },

  // Playoff Serif
  {
    family: 'Playoff Serif',
    weight: 400,
    style: 'normal',
    woff2: 'PlayoffSerifRegular.woff2',
    file: 'PlayoffSerifRegular.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Serif',
    weight: 400,
    style: 'italic',
    woff2: 'PlayoffSerifRegularItalic.woff2',
    file: 'PlayoffSerifRegularItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Serif',
    weight: 500,
    style: 'normal',
    woff2: 'PlayoffSerifMedium.woff2',
    file: 'PlayoffSerifMedium.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Serif',
    weight: 500,
    style: 'italic',
    woff2: 'PlayoffSerifMediumItalic.woff2',
    file: 'PlayoffSerifMediumItalic.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Serif',
    weight: 700,
    style: 'normal',
    woff2: 'PlayoffSerifBold.woff2',
    file: 'PlayoffSerifBold.otf',
    format: 'opentype'
  },
  {
    family: 'Playoff Serif',
    weight: 700,
    style: 'italic',
    woff2: 'PlayoffSerifBoldItalic.woff2',
    file: 'PlayoffSerifBoldItalic.otf',
    format: 'opentype'
  }
];

export function injectEspnFonts() {
  injectBrandFonts({ styleId: 'espn-fonts', baseUrl: FONT_BASE_URL, fonts: FONTS });
}
